/**
 * Injects a CSS fix into the GrowWave back-in-stock iframe so the email
 * input has a visible border (the app sets border-color === background-color).
 * Also fixes the close button which the app renders with color:#cccccc and
 * opacity:0.5, making it nearly invisible.
 * The iframe uses srcdoc and is same-origin, so we can access its contentDocument.
 */
(function () {
  const IFRAME_ID = 'gw-stock-fulfilled-iframe';

  const CSS = `
    .email-input {
      background-color: #ffffff !important;
      border-color: #dde1e7 !important;
      border-radius: 8px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
      transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
    }
    .email-input:focus {
      background-color: #ffffff !important;
      border-color: #192b4f !important;
      box-shadow: 0 0 0 1px #192b4f !important;
      outline: none !important;
    }
    .notify-button {
      background-color: #192b4f !important;
      color: #f8fafc !important;
      border: 0 !important;
      border-radius: 8px !important;
      font-family: Barlow, sans-serif !important;
      font-size: 15px !important;
      font-weight: 600 !important;
      padding: 14px !important;
      width: 100% !important;
      margin-top: 15px !important;
      cursor: pointer !important;
      transition: background-color 0.15s ease !important;
    }
    .notify-button:hover {
      background-color: #243a6b !important;
    }
    .close-icon {
      color: #000000 !important;
      opacity: 1 !important;
      font-size: 20px !important;
      font-weight: 700 !important;
    }
    .close-icon:hover {
      color: #000000 !important;
      opacity: 0.6 !important;
    }
  `;

  /**
   * @param {HTMLIFrameElement} iframe
   */
  function closeWidget(iframe) {
    iframe.style.display = 'none';
  }

  /**
   * @param {HTMLIFrameElement} iframe
   */
  function injectStyles(iframe) {
    try {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc || doc.getElementById('gw-custom-fix')) return;
      const style = doc.createElement('style');
      style.id = 'gw-custom-fix';
      style.textContent = CSS;
      (doc.head || doc.documentElement).appendChild(style);
    } catch (_) {}
  }

  /**
   * @param {HTMLIFrameElement} iframe
   */
  function handleIframe(iframe) {
    // Inject immediately if already loaded, else wait for load
    if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
      injectStyles(iframe);
    } else {
      iframe.addEventListener('load', () => injectStyles(iframe), { once: true });
    }

    // Also watch for display toggling (app hides/shows via style)
    new MutationObserver(() => {
      if (iframe.style.display !== 'none') {
        injectStyles(iframe);
      }
    }).observe(iframe, { attributes: true, attributeFilter: ['style'] });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (iframe.style.display === 'none') return;
      closeWidget(iframe);
    });
  }

  /**
   * Opens the iframe popup and populates variant data from the clicked button.
   * @param {HTMLButtonElement} btn
   * @param {HTMLIFrameElement} iframe
   */
  function openPopUp(btn, iframe) {
    const variantId = btn.dataset.variantId;
    const productId = btn.dataset.productId;

    iframe.style.display = 'block';

    // Let GrowWave's own initVar handle it if available
    if (window.initVar && typeof window.initVar.openCampaignPopUp === 'function') {
      window.initVar.openCampaignPopUp(IFRAME_ID, productId, variantId);
      return;
    }

    // Fallback: update the Vue instance inside the iframe directly
    try {
      const vueApp = window.growCampaignPopUps && window.growCampaignPopUps[IFRAME_ID];
      if (vueApp && variantId) {
        vueApp.selectedVariant = variantId;
      }
    } catch (_) {}
  }

  // Delegated click handler — catches buttons rendered at any point
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gw-collection-page-button');
    if (!btn) return;
    e.preventDefault();
    const iframe = document.getElementById(IFRAME_ID);
    if (iframe) {
      openPopUp(btn, iframe);
    }
  });

  // Handle iframe already in DOM
  const existing = document.getElementById(IFRAME_ID);
  if (existing instanceof HTMLIFrameElement) {
    handleIframe(existing);
    return;
  }

  // Wait for the app to inject the iframe
  new MutationObserver((mutations, observer) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof HTMLIFrameElement && node.id === IFRAME_ID) {
          handleIframe(node);
          observer.disconnect();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
